// export const parsePaymentDate = (rawDate) => {
//   if (!rawDate) return new Date(0);

//   const normalizeDigits = (str) => {
//     const persian = "۰۱۲۳۴۵۶۷۸۹";
//     const arabic = "٠١٢٣٤٥٦٧٨٩";
//     return str
//       ?.replace(/[۰-۹]/g, (d) => persian.indexOf(d))
//       ?.replace(/[٠-٩]/g, (d) => arabic.indexOf(d));
//   };

//   const normalized = normalizeDigits(rawDate.trim());

//   // YYYY-MM-DD
//   if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(normalized)) {
//     return new Date(normalized);
//   }

//   // DD/MM/YYYY or MM/DD/YYYY
//   if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(normalized)) {
//     const [p1, p2, year] = normalized.split("/").map(Number);

//     let day, month;
//     if (p1 > 12) {
//       day = p1;
//       month = p2; // DD/MM/YYYY
//     } else if (p2 > 12) {
//       day = p2;
//       month = p1; // MM/DD/YYYY
//     } else {
//       day = p2;
//       month = p1; // both <= 12 → assume MM/DD/YYYY
//     }
//     return new Date(year, month - 1, day);
//   }

//   // fallback
//   const fallback = new Date(normalized);
//   if (!isNaN(fallback.getTime())) return fallback;

//   return new Date(0);
// };

export const parsePaymentDate = (rawDate) => {
  if (rawDate === null || rawDate === undefined || rawDate === "") {
    return new Date(0);
  }
  if (rawDate instanceof Date && !Number.isNaN(rawDate.getTime())) {
    return rawDate;
  }
  if (typeof rawDate === "number" && !Number.isNaN(rawDate)) {
    const ms = rawDate > 1e12 ? rawDate : rawDate * 1000;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? new Date(0) : d;
  }
  if (typeof rawDate !== "string") {
    const d = new Date(rawDate);
    return Number.isNaN(d.getTime()) ? new Date(0) : d;
  }

  const normalizeDigits = (str) => {
    const persian = "۰۱۲۳۴۵۶۷۸۹";
    const arabic = "٠١٢٣٤٥٦٧٨٩";
    return str
      ?.replace(/[۰-۹]/g, (d) => persian.indexOf(d))
      ?.replace(/[٠-٩]/g, (d) => arabic.indexOf(d));
  };

  const normalized = normalizeDigits(rawDate.trim());

  // YYYY-MM-DD (calendar date in local time — avoid Date("YYYY-MM-DD") UTC shift)
  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(normalized)) {
    const [y, mo, d] = normalized.split("-").map(Number);
    return new Date(y, mo - 1, d);
  }

  // DD-MM-YYYY
  if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(normalized)) {
    const [day, month, year] = normalized.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  // DD/MM/YYYY or MM/DD/YYYY
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(normalized)) {
    const [p1, p2, year] = normalized.split("/").map(Number);

    let day, month;
    if (p1 > 12) {
      // must be DD/MM/YYYY (day > 12)
      day = p1;
      month = p2;
    } else if (p2 > 12) {
      // must be MM/DD/YYYY (month > 12)
      day = p2;
      month = p1;
    } else {
      // both ≤ 12 → DEFAULT to DD/MM/YYYY (day first) per project standard
      day = p1;
      month = p2;
    }
    return new Date(year, month - 1, day);
  }

  // fallback
  const fallback = new Date(normalized);
  if (!isNaN(fallback.getTime())) return fallback;

  return new Date(0);
};

export const formatDate = (rawDate) => {
  if (rawDate == null || rawDate === "") return "-";

  let date;
  if (rawDate instanceof Date && !Number.isNaN(rawDate.getTime())) {
    date = rawDate;
  } else if (typeof rawDate === "number" && !Number.isNaN(rawDate)) {
    const ms = rawDate > 1e12 ? rawDate : rawDate * 1000;
    date = new Date(ms);
  } else {
    date = parsePaymentDate(rawDate);
  }

  if (isNaN(date.getTime())) return "-";

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};
